import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/**
 * "Tour this page" for Domains (/domains and /settings/domain → SettingsDomainPage without the
 * go-live entryPoint). Anchors live in SettingsDomainPage.tsx. The tab anchors only render on a
 * plan that includes a custom domain; on other plans those steps are skipped.
 */
export function getDomainsTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Your domains',
        description:
          'This is where you manage your site’s web address — and connect a domain you own, like ' +
          'smithrealty.com. Custom domains are included on every paid plan.',
      },
    },
    {
      element: at('domains-surface'),
      popover: {
        title: 'Where your site lives',
        description:
          'Your free yourname.searchproperties.io address always works. Next to it is the address ' +
          'your site is live on right now, with its hosting status below.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('domains-connect'),
      popover: {
        title: 'Connect your domain',
        description:
          'Open this tab, type your domain, and click Connect. We’ll show you the DNS records to add ' +
          'where you bought your domain (GoDaddy, Namecheap, and so on).',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('domains-connected'),
      popover: {
        title: 'Connected domains',
        description:
          'Your domains appear here. After adding the DNS records, click Verify — changes can take ' +
          'up to an hour to show up. Once it’s ready, your security certificate is set up for you, ' +
          'and “Make primary” picks which domain visitors land on.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('domains-buy'),
      popover: {
        title: 'Check a domain',
        description:
          'Don’t have a domain yet? Search here to see if one is available. Buying through us isn’t ' +
          'available yet, so register it with a domain company, then connect it.',
        side: 'bottom',
        align: 'start',
      },
    },
  ];
}
